<template>
  <section>

<div class="row">
    <div class="card">
        <div class="card-image">
<!-- <img src="../../assets/card.png" alt=""> -->
        </div>
        <div class="card-body">
            <h3>Ocean yogs</h3>
            <img src="../../assets/card_tag.png" alt="">
            <button @click="modalbg = !modalbg">Buy Now!</button>
        </div>
</div>

    <div class="card">
        <div class="card-image">
<!-- <img src="../../assets/card.png" alt=""> -->
        </div>
        <div class="card-body">
            <h3>Ocean yogs</h3>
            <img src="../../assets/card_tag.png" alt="">
            <button @click="modalbg = !modalbg" >Buy Now!</button>
        </div>
</div>

    <div class="card">
        <div class="card-image">
<!-- <img src="../../assets/card.png" alt=""> -->
        </div>
        <div class="card-body">
            <h3>Ocean yogs</h3>
            <img src="../../assets/card_tag.png" alt="">
            <button @click="modalbg = !modalbg">Buy Now!</button>
        </div>
</div>

    <div class="card">
        <div class="card-image">
<!-- <img src="../../assets/card.png" alt=""> -->
        </div>
        <div class="card-body">
            <h3>Ocean yogs</h3>
            <img src="../../assets/card_tag.png" alt="">
            <button @click="modalbg = !modalbg">Buy Now!</button>
        </div>
</div>

    <div class="card">
        <div class="card-image">
<!-- <img src="../../assets/card.png" alt=""> -->
        </div>
        <div class="card-body">
            <h3>Ocean yogs</h3>
            <img src="../../assets/card_tag.png" alt="">
            <button @click="modalbg = !modalbg">Buy Now!</button>
        </div>
</div>
</div>


<div class="available">
<h3 class="also">Also available at </h3>
<img class="hamleys" src="../../assets/hamleys.png" alt="">
</div>
<transition name="modal" >
<BuyNow :modalbg="modalbg" v-if="modalbg" class="buynow"  @close="modalbg = !modalbg"/>
</transition>
  </section>

</template>

<script>

import BuyNow from "./BuyNow.vue"

export default {
components:{BuyNow},

data(){
    return{
        modalbg:false
    }
}
}
</script>

<style scoped>
.buynow{
    position: fixed;
    left: 0;
    top: 0;
     width: 100%;
    height: 70%;
     display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    
}
.modal-enter-from{
    opacity: 0;
    transform: scale(0);
    /* transform: translateY(400px); */
}
.modal-enter-to{
    opacity: 1;
    transform: scale(1);
}

.modal-enter-active {
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.modal-leave-from{
    opacity: 1;
    transform: scale(1);
    /* transform: translateY(400px); */
}
.modal-leave-to{
    opacity: 0;
    transform: scale(0);
}
.modal-leave-active {
  transition: all 0.3s ease;
}
.hamleys{
    padding-left: 5px;
}
.also{
color: #791E94;
    font-weight: 450;
} 

.available{
    display: flex;
    width: 90%;
    margin: auto;
}

.card h3{
    /* padding: 10px; */
    /* text-align: center; */
    font-family: Original Surfer;
font-weight: 400;
font-size: 20px;
color: white;
    
}
.card:hover{
transform: scale(1.1); 
}

.card-image{
    height: 235px;
    background-image: url(../../assets/card.png);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
}
button{
  display: block;
    color: white;
    background-color: #FF8100;
    border: none;
    padding: 15px 70px;
    border-radius: 10px;
    cursor: pointer;
    transition: 0.3s ease-in;
}
button:hover{
    background-color: #ca6500;
}
.card{
    
    background-color: #4BA3C3;
    width: 17%;
    height: 400px;
    margin-bottom: 50px;
    border-radius: 20px;
    /* border: 2px solid #000; */
    transition: transform .2s ease;
}
.row{
    display: flex;
    justify-content: space-around;
    /* flex-flow: wrap; */
    flex-wrap: wrap;
    width: 90%;
    margin: auto;
        margin-top: 125px;
}

.card-body{
  display: flex;
    flex-direction: column;
     align-items: center;
    justify-content: space-evenly;
        height: 157px;
}

.card-header{
    /* text-align: center; */
    display: flex;
    flex-direction: column;
     align-items: center;
    justify-content: space-evenly;

}


@media (max-width: 1770px){
    .card{
        width: 40%;
    }
}

@media (max-width: 620px){
    .card{
        width: 80%;
    }
}
</style>